import Vue from 'vue';
import SSE from 'vue-sse';
Vue.use(SSE);
import { apiUrl } from 'config';

let msgServer;
const vue = Vue;

export const sse = {
  subscribe,
  close,
};

function close() {
  console.log('SSE closing');
  msgServer.close();
}

function subscribe(callback) {
  (async () => {
    try {
      // Store SSE object at a higher scope
      msgServer = await vue.SSE(`${apiUrl}/sse`, { format: 'json' }); // omit for no format pre-processing

      // Catch any errors (ie. lost connections, etc.)
      msgServer.onError(e => {
        console.error('lost connection; giving up!', e);

        // This is purely for example; EventSource will automatically
        // attempt to reconnect indefinitely, with no action needed
        // on your part to resubscribe to events once (if) reconnected
        msgServer.close();
      });

      // Listen for messages without a specified event
      msgServer.subscribe('', data => {
        // console.log('Received a message w/o an event!', data);
        if (typeof callback === 'function') {
          callback(data);
        }
      });
    } catch (err) {
      // When this error is caught, it means the initial connection to the
      // events server failed.  No automatic attempts to reconnect will be made.
      console.error('Failed to connect to server', err);
    }
  })();
}
